/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { EnumTypeModel } from '../models/enum-type-model';
import { KeyValueCodeModel } from '../models/key-value-code-model';
import { KeyValueModel } from '../models/key-value-model';
import { masterDataAddressTypesGet } from '../fn/master-data/master-data-address-types-get';
import { MasterDataAddressTypesGet$Params } from '../fn/master-data/master-data-address-types-get';
import { masterDataAddressUseTypesGet } from '../fn/master-data/master-data-address-use-types-get';
import { MasterDataAddressUseTypesGet$Params } from '../fn/master-data/master-data-address-use-types-get';
import { masterDataContactPointTypeLookupByKeyPost } from '../fn/master-data/master-data-contact-point-type-lookup-by-key-post';
import { MasterDataContactPointTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-contact-point-type-lookup-by-key-post';
import { masterDataContactPointTypeLookupByValueGet } from '../fn/master-data/master-data-contact-point-type-lookup-by-value-get';
import { MasterDataContactPointTypeLookupByValueGet$Params } from '../fn/master-data/master-data-contact-point-type-lookup-by-value-get';
import { masterDataContactPointTypesGet } from '../fn/master-data/master-data-contact-point-types-get';
import { MasterDataContactPointTypesGet$Params } from '../fn/master-data/master-data-contact-point-types-get';
import { masterDataCountriesGet } from '../fn/master-data/master-data-countries-get';
import { MasterDataCountriesGet$Params } from '../fn/master-data/master-data-countries-get';
import { masterDataCountryLookupByKeyPost } from '../fn/master-data/master-data-country-lookup-by-key-post';
import { MasterDataCountryLookupByKeyPost$Params } from '../fn/master-data/master-data-country-lookup-by-key-post';
import { masterDataCountryLookupByValueGet } from '../fn/master-data/master-data-country-lookup-by-value-get';
import { MasterDataCountryLookupByValueGet$Params } from '../fn/master-data/master-data-country-lookup-by-value-get';
import { masterDataEducationSubFieldLookupByKeyPost } from '../fn/master-data/master-data-education-sub-field-lookup-by-key-post';
import { MasterDataEducationSubFieldLookupByKeyPost$Params } from '../fn/master-data/master-data-education-sub-field-lookup-by-key-post';
import { masterDataEducationSubFieldLookupByValueGet } from '../fn/master-data/master-data-education-sub-field-lookup-by-value-get';
import { MasterDataEducationSubFieldLookupByValueGet$Params } from '../fn/master-data/master-data-education-sub-field-lookup-by-value-get';
import { masterDataEducationSubFieldsGet } from '../fn/master-data/master-data-education-sub-fields-get';
import { MasterDataEducationSubFieldsGet$Params } from '../fn/master-data/master-data-education-sub-fields-get';
import { masterDataEnumTypeModelGet } from '../fn/master-data/master-data-enum-type-model-get';
import { MasterDataEnumTypeModelGet$Params } from '../fn/master-data/master-data-enum-type-model-get';
import { masterDataGenderTypesGet } from '../fn/master-data/master-data-gender-types-get';
import { MasterDataGenderTypesGet$Params } from '../fn/master-data/master-data-gender-types-get';
import { masterDataIcd10CodeGet } from '../fn/master-data/master-data-icd-10-code-get';
import { MasterDataIcd10CodeGet$Params } from '../fn/master-data/master-data-icd-10-code-get';
import { masterDataIcd10CodeLookupByKeyPost } from '../fn/master-data/master-data-icd-10-code-lookup-by-key-post';
import { MasterDataIcd10CodeLookupByKeyPost$Params } from '../fn/master-data/master-data-icd-10-code-lookup-by-key-post';
import { masterDataIcd10CodeLookupByValueGet } from '../fn/master-data/master-data-icd-10-code-lookup-by-value-get';
import { MasterDataIcd10CodeLookupByValueGet$Params } from '../fn/master-data/master-data-icd-10-code-lookup-by-value-get';
import { masterDataLanguageTypesGet } from '../fn/master-data/master-data-language-types-get';
import { MasterDataLanguageTypesGet$Params } from '../fn/master-data/master-data-language-types-get';
import { masterDataLocationPhysicalTypeLookupByKeyPost } from '../fn/master-data/master-data-location-physical-type-lookup-by-key-post';
import { MasterDataLocationPhysicalTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-location-physical-type-lookup-by-key-post';
import { masterDataLocationPhysicalTypeLookupByValueGet } from '../fn/master-data/master-data-location-physical-type-lookup-by-value-get';
import { MasterDataLocationPhysicalTypeLookupByValueGet$Params } from '../fn/master-data/master-data-location-physical-type-lookup-by-value-get';
import { masterDataLocationPhysicalTypesGet } from '../fn/master-data/master-data-location-physical-types-get';
import { MasterDataLocationPhysicalTypesGet$Params } from '../fn/master-data/master-data-location-physical-types-get';
import { masterDataLocationTypesGet } from '../fn/master-data/master-data-location-types-get';
import { MasterDataLocationTypesGet$Params } from '../fn/master-data/master-data-location-types-get';
import { masterDataLogoUseTypeLookupByKeyPost } from '../fn/master-data/master-data-logo-use-type-lookup-by-key-post';
import { MasterDataLogoUseTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-logo-use-type-lookup-by-key-post';
import { masterDataLogoUseTypeLookupByValueGet } from '../fn/master-data/master-data-logo-use-type-lookup-by-value-get';
import { MasterDataLogoUseTypeLookupByValueGet$Params } from '../fn/master-data/master-data-logo-use-type-lookup-by-value-get';
import { masterDataLogoUseTypesGet } from '../fn/master-data/master-data-logo-use-types-get';
import { MasterDataLogoUseTypesGet$Params } from '../fn/master-data/master-data-logo-use-types-get';
import { masterDataMaritalStatusTypesGet } from '../fn/master-data/master-data-marital-status-types-get';
import { MasterDataMaritalStatusTypesGet$Params } from '../fn/master-data/master-data-marital-status-types-get';
import { masterDataMedicalAidGet } from '../fn/master-data/master-data-medical-aid-get';
import { MasterDataMedicalAidGet$Params } from '../fn/master-data/master-data-medical-aid-get';
import { masterDataMedicalAidLookupByKeyPost } from '../fn/master-data/master-data-medical-aid-lookup-by-key-post';
import { MasterDataMedicalAidLookupByKeyPost$Params } from '../fn/master-data/master-data-medical-aid-lookup-by-key-post';
import { masterDataMedicalAidLookupByValueGet } from '../fn/master-data/master-data-medical-aid-lookup-by-value-get';
import { MasterDataMedicalAidLookupByValueGet$Params } from '../fn/master-data/master-data-medical-aid-lookup-by-value-get';
import { masterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet } from '../fn/master-data/master-data-medical-aid-option-medical-aid-id-medical-aid-scheme-id-get';
import { MasterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet$Params } from '../fn/master-data/master-data-medical-aid-option-medical-aid-id-medical-aid-scheme-id-get';
import { masterDataMedicalAidSchemeMedicalAidIdGet } from '../fn/master-data/master-data-medical-aid-scheme-medical-aid-id-get';
import { MasterDataMedicalAidSchemeMedicalAidIdGet$Params } from '../fn/master-data/master-data-medical-aid-scheme-medical-aid-id-get';
import { masterDataNappiCodeLookupByCodePost } from '../fn/master-data/master-data-nappi-code-lookup-by-code-post';
import { MasterDataNappiCodeLookupByCodePost$Params } from '../fn/master-data/master-data-nappi-code-lookup-by-code-post';
import { masterDataNappiCodeLookupByKeyPost } from '../fn/master-data/master-data-nappi-code-lookup-by-key-post';
import { MasterDataNappiCodeLookupByKeyPost$Params } from '../fn/master-data/master-data-nappi-code-lookup-by-key-post';
import { masterDataNappiCodeLookupByValueGet } from '../fn/master-data/master-data-nappi-code-lookup-by-value-get';
import { MasterDataNappiCodeLookupByValueGet$Params } from '../fn/master-data/master-data-nappi-code-lookup-by-value-get';
import { masterDataNappiCodesGet } from '../fn/master-data/master-data-nappi-codes-get';
import { MasterDataNappiCodesGet$Params } from '../fn/master-data/master-data-nappi-codes-get';
import { masterDataOrganizationContactTypesGet } from '../fn/master-data/master-data-organization-contact-types-get';
import { MasterDataOrganizationContactTypesGet$Params } from '../fn/master-data/master-data-organization-contact-types-get';
import { masterDataOrganizationRoleLookupByKeyPost } from '../fn/master-data/master-data-organization-role-lookup-by-key-post';
import { MasterDataOrganizationRoleLookupByKeyPost$Params } from '../fn/master-data/master-data-organization-role-lookup-by-key-post';
import { masterDataOrganizationRoleLookupByValueGet } from '../fn/master-data/master-data-organization-role-lookup-by-value-get';
import { MasterDataOrganizationRoleLookupByValueGet$Params } from '../fn/master-data/master-data-organization-role-lookup-by-value-get';
import { masterDataOrganizationRolesGet } from '../fn/master-data/master-data-organization-roles-get';
import { MasterDataOrganizationRolesGet$Params } from '../fn/master-data/master-data-organization-roles-get';
import { masterDataOrganizationTypeLookupByKeyPost } from '../fn/master-data/master-data-organization-type-lookup-by-key-post';
import { MasterDataOrganizationTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-organization-type-lookup-by-key-post';
import { masterDataOrganizationTypeLookupByValueGet } from '../fn/master-data/master-data-organization-type-lookup-by-value-get';
import { MasterDataOrganizationTypeLookupByValueGet$Params } from '../fn/master-data/master-data-organization-type-lookup-by-value-get';
import { masterDataOrganizationTypesGet } from '../fn/master-data/master-data-organization-types-get';
import { MasterDataOrganizationTypesGet$Params } from '../fn/master-data/master-data-organization-types-get';
import { masterDataPersonIdentifierTypesGet } from '../fn/master-data/master-data-person-identifier-types-get';
import { MasterDataPersonIdentifierTypesGet$Params } from '../fn/master-data/master-data-person-identifier-types-get';
import { masterDataPracticeTypeLookupByKeyPost } from '../fn/master-data/master-data-practice-type-lookup-by-key-post';
import { MasterDataPracticeTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-practice-type-lookup-by-key-post';
import { masterDataPracticeTypeLookupByValueGet } from '../fn/master-data/master-data-practice-type-lookup-by-value-get';
import { MasterDataPracticeTypeLookupByValueGet$Params } from '../fn/master-data/master-data-practice-type-lookup-by-value-get';
import { masterDataPracticeTypesGet } from '../fn/master-data/master-data-practice-types-get';
import { MasterDataPracticeTypesGet$Params } from '../fn/master-data/master-data-practice-types-get';
import { masterDataPreferredEmailTypesGet } from '../fn/master-data/master-data-preferred-email-types-get';
import { MasterDataPreferredEmailTypesGet$Params } from '../fn/master-data/master-data-preferred-email-types-get';
import { masterDataProductBenefitLookupByKeyPost } from '../fn/master-data/master-data-product-benefit-lookup-by-key-post';
import { MasterDataProductBenefitLookupByKeyPost$Params } from '../fn/master-data/master-data-product-benefit-lookup-by-key-post';
import { masterDataProductBenefitLookupByValueGet } from '../fn/master-data/master-data-product-benefit-lookup-by-value-get';
import { MasterDataProductBenefitLookupByValueGet$Params } from '../fn/master-data/master-data-product-benefit-lookup-by-value-get';
import { masterDataProductBenefitQueryGet } from '../fn/master-data/master-data-product-benefit-query-get';
import { MasterDataProductBenefitQueryGet$Params } from '../fn/master-data/master-data-product-benefit-query-get';
import { masterDataProfessionLookupByKeyPost } from '../fn/master-data/master-data-profession-lookup-by-key-post';
import { MasterDataProfessionLookupByKeyPost$Params } from '../fn/master-data/master-data-profession-lookup-by-key-post';
import { masterDataProfessionLookupByValueGet } from '../fn/master-data/master-data-profession-lookup-by-value-get';
import { MasterDataProfessionLookupByValueGet$Params } from '../fn/master-data/master-data-profession-lookup-by-value-get';
import { masterDataProfessionsGet } from '../fn/master-data/master-data-professions-get';
import { MasterDataProfessionsGet$Params } from '../fn/master-data/master-data-professions-get';
import { masterDataPublicHolidayLookupByKeyPost } from '../fn/master-data/master-data-public-holiday-lookup-by-key-post';
import { MasterDataPublicHolidayLookupByKeyPost$Params } from '../fn/master-data/master-data-public-holiday-lookup-by-key-post';
import { masterDataPublicHolidayLookupByValueGet } from '../fn/master-data/master-data-public-holiday-lookup-by-value-get';
import { MasterDataPublicHolidayLookupByValueGet$Params } from '../fn/master-data/master-data-public-holiday-lookup-by-value-get';
import { masterDataPublicHolidaysGet } from '../fn/master-data/master-data-public-holidays-get';
import { MasterDataPublicHolidaysGet$Params } from '../fn/master-data/master-data-public-holidays-get';
import { masterDataQualificationLookupByKeyPost } from '../fn/master-data/master-data-qualification-lookup-by-key-post';
import { MasterDataQualificationLookupByKeyPost$Params } from '../fn/master-data/master-data-qualification-lookup-by-key-post';
import { masterDataQualificationLookupByValueGet } from '../fn/master-data/master-data-qualification-lookup-by-value-get';
import { MasterDataQualificationLookupByValueGet$Params } from '../fn/master-data/master-data-qualification-lookup-by-value-get';
import { masterDataQualificationsQualificationTypeIdGet } from '../fn/master-data/master-data-qualifications-qualification-type-id-get';
import { MasterDataQualificationsQualificationTypeIdGet$Params } from '../fn/master-data/master-data-qualifications-qualification-type-id-get';
import { masterDataQualificationTypeLookupByKeyPost } from '../fn/master-data/master-data-qualification-type-lookup-by-key-post';
import { MasterDataQualificationTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-qualification-type-lookup-by-key-post';
import { masterDataQualificationTypeLookupByValueGet } from '../fn/master-data/master-data-qualification-type-lookup-by-value-get';
import { MasterDataQualificationTypeLookupByValueGet$Params } from '../fn/master-data/master-data-qualification-type-lookup-by-value-get';
import { masterDataQualificationTypesGet } from '../fn/master-data/master-data-qualification-types-get';
import { MasterDataQualificationTypesGet$Params } from '../fn/master-data/master-data-qualification-types-get';
import { masterDataRelationshipTypeLookupByKeyPost } from '../fn/master-data/master-data-relationship-type-lookup-by-key-post';
import { MasterDataRelationshipTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-relationship-type-lookup-by-key-post';
import { masterDataRelationshipTypeLookupByValueGet } from '../fn/master-data/master-data-relationship-type-lookup-by-value-get';
import { MasterDataRelationshipTypeLookupByValueGet$Params } from '../fn/master-data/master-data-relationship-type-lookup-by-value-get';
import { masterDataRelationshipTypesGet } from '../fn/master-data/master-data-relationship-types-get';
import { MasterDataRelationshipTypesGet$Params } from '../fn/master-data/master-data-relationship-types-get';
import { masterDataServiceCategoriesGet } from '../fn/master-data/master-data-service-categories-get';
import { MasterDataServiceCategoriesGet$Params } from '../fn/master-data/master-data-service-categories-get';
import { masterDataServiceCategoryLookupByKeyPost } from '../fn/master-data/master-data-service-category-lookup-by-key-post';
import { MasterDataServiceCategoryLookupByKeyPost$Params } from '../fn/master-data/master-data-service-category-lookup-by-key-post';
import { masterDataServiceCategoryLookupByValueGet } from '../fn/master-data/master-data-service-category-lookup-by-value-get';
import { MasterDataServiceCategoryLookupByValueGet$Params } from '../fn/master-data/master-data-service-category-lookup-by-value-get';
import { masterDataServiceDeliveryLocationRoleTypeLookupByKeyPost } from '../fn/master-data/master-data-service-delivery-location-role-type-lookup-by-key-post';
import { MasterDataServiceDeliveryLocationRoleTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-service-delivery-location-role-type-lookup-by-key-post';
import { masterDataServiceDeliveryLocationRoleTypeLookupByValueGet } from '../fn/master-data/master-data-service-delivery-location-role-type-lookup-by-value-get';
import { MasterDataServiceDeliveryLocationRoleTypeLookupByValueGet$Params } from '../fn/master-data/master-data-service-delivery-location-role-type-lookup-by-value-get';
import { masterDataServiceDeliveryLocationRoleTypesGet } from '../fn/master-data/master-data-service-delivery-location-role-types-get';
import { MasterDataServiceDeliveryLocationRoleTypesGet$Params } from '../fn/master-data/master-data-service-delivery-location-role-types-get';
import { masterDataServiceTypeLookupByKeyPost } from '../fn/master-data/master-data-service-type-lookup-by-key-post';
import { MasterDataServiceTypeLookupByKeyPost$Params } from '../fn/master-data/master-data-service-type-lookup-by-key-post';
import { masterDataServiceTypeLookupByValueGet } from '../fn/master-data/master-data-service-type-lookup-by-value-get';
import { MasterDataServiceTypeLookupByValueGet$Params } from '../fn/master-data/master-data-service-type-lookup-by-value-get';
import { masterDataServiceTypesGet } from '../fn/master-data/master-data-service-types-get';
import { MasterDataServiceTypesGet$Params } from '../fn/master-data/master-data-service-types-get';
import { masterDataSystemIdentifierLookupByKeyPost } from '../fn/master-data/master-data-system-identifier-lookup-by-key-post';
import { MasterDataSystemIdentifierLookupByKeyPost$Params } from '../fn/master-data/master-data-system-identifier-lookup-by-key-post';
import { masterDataSystemIdentifierLookupByValueGet } from '../fn/master-data/master-data-system-identifier-lookup-by-value-get';
import { MasterDataSystemIdentifierLookupByValueGet$Params } from '../fn/master-data/master-data-system-identifier-lookup-by-value-get';
import { masterDataSystemIdentifiersGet } from '../fn/master-data/master-data-system-identifiers-get';
import { MasterDataSystemIdentifiersGet$Params } from '../fn/master-data/master-data-system-identifiers-get';
import { masterDataTimeZonesGet } from '../fn/master-data/master-data-time-zones-get';
import { MasterDataTimeZonesGet$Params } from '../fn/master-data/master-data-time-zones-get';
import { masterDataTitleLookupByKeyPost } from '../fn/master-data/master-data-title-lookup-by-key-post';
import { MasterDataTitleLookupByKeyPost$Params } from '../fn/master-data/master-data-title-lookup-by-key-post';
import { masterDataTitleLookupByValueGet } from '../fn/master-data/master-data-title-lookup-by-value-get';
import { MasterDataTitleLookupByValueGet$Params } from '../fn/master-data/master-data-title-lookup-by-value-get';
import { masterDataTitlesGet } from '../fn/master-data/master-data-titles-get';
import { MasterDataTitlesGet$Params } from '../fn/master-data/master-data-titles-get';
import { NappiCodeDescriptionModel } from '../models/nappi-code-description-model';
import { NappiCodeListModel } from '../models/nappi-code-list-model';
import { PublicHolidayListModel } from '../models/public-holiday-list-model';
import { QualificationKeyValueCodeModel } from '../models/qualification-key-value-code-model';
import { RelationshipTypeKeyValueModel } from '../models/relationship-type-key-value-model';
import { TimeZoneModel } from '../models/time-zone-model';

@Injectable({ providedIn: 'root' })
export class MDIMasterDataService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `masterDataServiceDeliveryLocationRoleTypesGet()` */
  static readonly MasterDataServiceDeliveryLocationRoleTypesGetPath = '/MasterData/ServiceDeliveryLocationRoleTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceDeliveryLocationRoleTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceDeliveryLocationRoleTypesGet$Response(params?: MasterDataServiceDeliveryLocationRoleTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceDeliveryLocationRoleTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceDeliveryLocationRoleTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceDeliveryLocationRoleTypesGet(params?: MasterDataServiceDeliveryLocationRoleTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceDeliveryLocationRoleTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataServiceDeliveryLocationRoleTypeLookupByKeyPost()` */
  static readonly MasterDataServiceDeliveryLocationRoleTypeLookupByKeyPostPath = '/MasterData/ServiceDeliveryLocationRoleTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceDeliveryLocationRoleTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataServiceDeliveryLocationRoleTypeLookupByKeyPost$Response(params?: MasterDataServiceDeliveryLocationRoleTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceDeliveryLocationRoleTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceDeliveryLocationRoleTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataServiceDeliveryLocationRoleTypeLookupByKeyPost(params?: MasterDataServiceDeliveryLocationRoleTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceDeliveryLocationRoleTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataServiceDeliveryLocationRoleTypeLookupByValueGet()` */
  static readonly MasterDataServiceDeliveryLocationRoleTypeLookupByValueGetPath = '/MasterData/ServiceDeliveryLocationRoleTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceDeliveryLocationRoleTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceDeliveryLocationRoleTypeLookupByValueGet$Response(params?: MasterDataServiceDeliveryLocationRoleTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceDeliveryLocationRoleTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceDeliveryLocationRoleTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceDeliveryLocationRoleTypeLookupByValueGet(params?: MasterDataServiceDeliveryLocationRoleTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceDeliveryLocationRoleTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataServiceTypesGet()` */
  static readonly MasterDataServiceTypesGetPath = '/MasterData/ServiceTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceTypesGet$Response(params?: MasterDataServiceTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceTypesGet(params?: MasterDataServiceTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataServiceTypeLookupByKeyPost()` */
  static readonly MasterDataServiceTypeLookupByKeyPostPath = '/MasterData/ServiceTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataServiceTypeLookupByKeyPost$Response(params?: MasterDataServiceTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataServiceTypeLookupByKeyPost(params?: MasterDataServiceTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataServiceTypeLookupByValueGet()` */
  static readonly MasterDataServiceTypeLookupByValueGetPath = '/MasterData/ServiceTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceTypeLookupByValueGet$Response(params?: MasterDataServiceTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceTypeLookupByValueGet(params?: MasterDataServiceTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataSystemIdentifiersGet()` */
  static readonly MasterDataSystemIdentifiersGetPath = '/MasterData/SystemIdentifiers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataSystemIdentifiersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataSystemIdentifiersGet$Response(params?: MasterDataSystemIdentifiersGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataSystemIdentifiersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataSystemIdentifiersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataSystemIdentifiersGet(params?: MasterDataSystemIdentifiersGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataSystemIdentifiersGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataSystemIdentifierLookupByKeyPost()` */
  static readonly MasterDataSystemIdentifierLookupByKeyPostPath = '/MasterData/SystemIdentifierLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataSystemIdentifierLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataSystemIdentifierLookupByKeyPost$Response(params?: MasterDataSystemIdentifierLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataSystemIdentifierLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataSystemIdentifierLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataSystemIdentifierLookupByKeyPost(params?: MasterDataSystemIdentifierLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataSystemIdentifierLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataSystemIdentifierLookupByValueGet()` */
  static readonly MasterDataSystemIdentifierLookupByValueGetPath = '/MasterData/SystemIdentifierLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataSystemIdentifierLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataSystemIdentifierLookupByValueGet$Response(params?: MasterDataSystemIdentifierLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataSystemIdentifierLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataSystemIdentifierLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataSystemIdentifierLookupByValueGet(params?: MasterDataSystemIdentifierLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataSystemIdentifierLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataTimeZonesGet()` */
  static readonly MasterDataTimeZonesGetPath = '/MasterData/TimeZones';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataTimeZonesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataTimeZonesGet$Response(params?: MasterDataTimeZonesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<TimeZoneModel>>> {
    return masterDataTimeZonesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataTimeZonesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataTimeZonesGet(params?: MasterDataTimeZonesGet$Params, context?: HttpContext): Observable<Array<TimeZoneModel>> {
    return this.masterDataTimeZonesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<TimeZoneModel>>): Array<TimeZoneModel> => r.body)
    );
  }

  /** Path part for operation `masterDataTitlesGet()` */
  static readonly MasterDataTitlesGetPath = '/MasterData/Titles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataTitlesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataTitlesGet$Response(params?: MasterDataTitlesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataTitlesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataTitlesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataTitlesGet(params?: MasterDataTitlesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataTitlesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataTitleLookupByKeyPost()` */
  static readonly MasterDataTitleLookupByKeyPostPath = '/MasterData/TitleLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataTitleLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataTitleLookupByKeyPost$Response(params?: MasterDataTitleLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataTitleLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataTitleLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataTitleLookupByKeyPost(params?: MasterDataTitleLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataTitleLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataTitleLookupByValueGet()` */
  static readonly MasterDataTitleLookupByValueGetPath = '/MasterData/TitleLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataTitleLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataTitleLookupByValueGet$Response(params?: MasterDataTitleLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataTitleLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataTitleLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataTitleLookupByValueGet(params?: MasterDataTitleLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataTitleLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataContactPointTypesGet()` */
  static readonly MasterDataContactPointTypesGetPath = '/MasterData/ContactPointTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataContactPointTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataContactPointTypesGet$Response(params?: MasterDataContactPointTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataContactPointTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataContactPointTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataContactPointTypesGet(params?: MasterDataContactPointTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataContactPointTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataContactPointTypeLookupByKeyPost()` */
  static readonly MasterDataContactPointTypeLookupByKeyPostPath = '/MasterData/ContactPointTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataContactPointTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataContactPointTypeLookupByKeyPost$Response(params?: MasterDataContactPointTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataContactPointTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataContactPointTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataContactPointTypeLookupByKeyPost(params?: MasterDataContactPointTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataContactPointTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataContactPointTypeLookupByValueGet()` */
  static readonly MasterDataContactPointTypeLookupByValueGetPath = '/MasterData/ContactPointTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataContactPointTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataContactPointTypeLookupByValueGet$Response(params?: MasterDataContactPointTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataContactPointTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataContactPointTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataContactPointTypeLookupByValueGet(params?: MasterDataContactPointTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataContactPointTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataCountriesGet()` */
  static readonly MasterDataCountriesGetPath = '/MasterData/Countries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataCountriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataCountriesGet$Response(params?: MasterDataCountriesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataCountriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataCountriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataCountriesGet(params?: MasterDataCountriesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataCountriesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataCountryLookupByKeyPost()` */
  static readonly MasterDataCountryLookupByKeyPostPath = '/MasterData/CountryLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataCountryLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataCountryLookupByKeyPost$Response(params?: MasterDataCountryLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataCountryLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataCountryLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataCountryLookupByKeyPost(params?: MasterDataCountryLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataCountryLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataCountryLookupByValueGet()` */
  static readonly MasterDataCountryLookupByValueGetPath = '/MasterData/CountryLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataCountryLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataCountryLookupByValueGet$Response(params?: MasterDataCountryLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataCountryLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataCountryLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataCountryLookupByValueGet(params?: MasterDataCountryLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataCountryLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataEducationSubFieldsGet()` */
  static readonly MasterDataEducationSubFieldsGetPath = '/MasterData/EducationSubFields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataEducationSubFieldsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataEducationSubFieldsGet$Response(params?: MasterDataEducationSubFieldsGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataEducationSubFieldsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataEducationSubFieldsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataEducationSubFieldsGet(params?: MasterDataEducationSubFieldsGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataEducationSubFieldsGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataEducationSubFieldLookupByKeyPost()` */
  static readonly MasterDataEducationSubFieldLookupByKeyPostPath = '/MasterData/EducationSubFieldLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataEducationSubFieldLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataEducationSubFieldLookupByKeyPost$Response(params?: MasterDataEducationSubFieldLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataEducationSubFieldLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataEducationSubFieldLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataEducationSubFieldLookupByKeyPost(params?: MasterDataEducationSubFieldLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataEducationSubFieldLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataEducationSubFieldLookupByValueGet()` */
  static readonly MasterDataEducationSubFieldLookupByValueGetPath = '/MasterData/EducationSubFieldLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataEducationSubFieldLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataEducationSubFieldLookupByValueGet$Response(params?: MasterDataEducationSubFieldLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataEducationSubFieldLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataEducationSubFieldLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataEducationSubFieldLookupByValueGet(params?: MasterDataEducationSubFieldLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataEducationSubFieldLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataLanguageTypesGet()` */
  static readonly MasterDataLanguageTypesGetPath = '/MasterData/LanguageTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataLanguageTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLanguageTypesGet$Response(params?: MasterDataLanguageTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataLanguageTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataLanguageTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLanguageTypesGet(params?: MasterDataLanguageTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataLanguageTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataOrganizationContactTypesGet()` */
  static readonly MasterDataOrganizationContactTypesGetPath = '/MasterData/OrganizationContactTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataOrganizationContactTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationContactTypesGet$Response(params?: MasterDataOrganizationContactTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataOrganizationContactTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataOrganizationContactTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationContactTypesGet(params?: MasterDataOrganizationContactTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataOrganizationContactTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataGenderTypesGet()` */
  static readonly MasterDataGenderTypesGetPath = '/MasterData/GenderTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataGenderTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataGenderTypesGet$Response(params?: MasterDataGenderTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataGenderTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataGenderTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataGenderTypesGet(params?: MasterDataGenderTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataGenderTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataMaritalStatusTypesGet()` */
  static readonly MasterDataMaritalStatusTypesGetPath = '/MasterData/MaritalStatusTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataMaritalStatusTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMaritalStatusTypesGet$Response(params?: MasterDataMaritalStatusTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataMaritalStatusTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataMaritalStatusTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMaritalStatusTypesGet(params?: MasterDataMaritalStatusTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataMaritalStatusTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataAddressUseTypesGet()` */
  static readonly MasterDataAddressUseTypesGetPath = '/MasterData/AddressUseTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataAddressUseTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataAddressUseTypesGet$Response(params?: MasterDataAddressUseTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataAddressUseTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataAddressUseTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataAddressUseTypesGet(params?: MasterDataAddressUseTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataAddressUseTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataAddressTypesGet()` */
  static readonly MasterDataAddressTypesGetPath = '/MasterData/AddressTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataAddressTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataAddressTypesGet$Response(params?: MasterDataAddressTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataAddressTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataAddressTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataAddressTypesGet(params?: MasterDataAddressTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataAddressTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPreferredEmailTypesGet()` */
  static readonly MasterDataPreferredEmailTypesGetPath = '/MasterData/PreferredEmailTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPreferredEmailTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPreferredEmailTypesGet$Response(params?: MasterDataPreferredEmailTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataPreferredEmailTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPreferredEmailTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPreferredEmailTypesGet(params?: MasterDataPreferredEmailTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataPreferredEmailTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPersonIdentifierTypesGet()` */
  static readonly MasterDataPersonIdentifierTypesGetPath = '/MasterData/PersonIdentifierTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPersonIdentifierTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPersonIdentifierTypesGet$Response(params?: MasterDataPersonIdentifierTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataPersonIdentifierTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPersonIdentifierTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPersonIdentifierTypesGet(params?: MasterDataPersonIdentifierTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataPersonIdentifierTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataLocationTypesGet()` */
  static readonly MasterDataLocationTypesGetPath = '/MasterData/LocationTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataLocationTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLocationTypesGet$Response(params?: MasterDataLocationTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataLocationTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataLocationTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLocationTypesGet(params?: MasterDataLocationTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataLocationTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataEnumTypeModelGet()` */
  static readonly MasterDataEnumTypeModelGetPath = '/MasterData/EnumTypeModel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataEnumTypeModelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataEnumTypeModelGet$Response(params?: MasterDataEnumTypeModelGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<EnumTypeModel>> {
    return masterDataEnumTypeModelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataEnumTypeModelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataEnumTypeModelGet(params?: MasterDataEnumTypeModelGet$Params, context?: HttpContext): Observable<EnumTypeModel> {
    return this.masterDataEnumTypeModelGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<EnumTypeModel>): EnumTypeModel => r.body)
    );
  }

  /** Path part for operation `masterDataIcd10CodeGet()` */
  static readonly MasterDataIcd10CodeGetPath = '/MasterData/ICD10Code';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataIcd10CodeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataIcd10CodeGet$Response(params?: MasterDataIcd10CodeGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataIcd10CodeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataIcd10CodeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataIcd10CodeGet(params?: MasterDataIcd10CodeGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataIcd10CodeGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataIcd10CodeLookupByKeyPost()` */
  static readonly MasterDataIcd10CodeLookupByKeyPostPath = '/MasterData/ICD10CodeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataIcd10CodeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataIcd10CodeLookupByKeyPost$Response(params?: MasterDataIcd10CodeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataIcd10CodeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataIcd10CodeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataIcd10CodeLookupByKeyPost(params?: MasterDataIcd10CodeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataIcd10CodeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataIcd10CodeLookupByValueGet()` */
  static readonly MasterDataIcd10CodeLookupByValueGetPath = '/MasterData/ICD10CodeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataIcd10CodeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataIcd10CodeLookupByValueGet$Response(params?: MasterDataIcd10CodeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataIcd10CodeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataIcd10CodeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataIcd10CodeLookupByValueGet(params?: MasterDataIcd10CodeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataIcd10CodeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataLocationPhysicalTypesGet()` */
  static readonly MasterDataLocationPhysicalTypesGetPath = '/MasterData/LocationPhysicalTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataLocationPhysicalTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLocationPhysicalTypesGet$Response(params?: MasterDataLocationPhysicalTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataLocationPhysicalTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataLocationPhysicalTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLocationPhysicalTypesGet(params?: MasterDataLocationPhysicalTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataLocationPhysicalTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataLocationPhysicalTypeLookupByKeyPost()` */
  static readonly MasterDataLocationPhysicalTypeLookupByKeyPostPath = '/MasterData/LocationPhysicalTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataLocationPhysicalTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataLocationPhysicalTypeLookupByKeyPost$Response(params?: MasterDataLocationPhysicalTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataLocationPhysicalTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataLocationPhysicalTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataLocationPhysicalTypeLookupByKeyPost(params?: MasterDataLocationPhysicalTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataLocationPhysicalTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataLocationPhysicalTypeLookupByValueGet()` */
  static readonly MasterDataLocationPhysicalTypeLookupByValueGetPath = '/MasterData/LocationPhysicalTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataLocationPhysicalTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLocationPhysicalTypeLookupByValueGet$Response(params?: MasterDataLocationPhysicalTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataLocationPhysicalTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataLocationPhysicalTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLocationPhysicalTypeLookupByValueGet(params?: MasterDataLocationPhysicalTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataLocationPhysicalTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataLogoUseTypesGet()` */
  static readonly MasterDataLogoUseTypesGetPath = '/MasterData/LogoUseTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataLogoUseTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLogoUseTypesGet$Response(params?: MasterDataLogoUseTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataLogoUseTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataLogoUseTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLogoUseTypesGet(params?: MasterDataLogoUseTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataLogoUseTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataLogoUseTypeLookupByKeyPost()` */
  static readonly MasterDataLogoUseTypeLookupByKeyPostPath = '/MasterData/LogoUseTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataLogoUseTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataLogoUseTypeLookupByKeyPost$Response(params?: MasterDataLogoUseTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataLogoUseTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataLogoUseTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataLogoUseTypeLookupByKeyPost(params?: MasterDataLogoUseTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataLogoUseTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataLogoUseTypeLookupByValueGet()` */
  static readonly MasterDataLogoUseTypeLookupByValueGetPath = '/MasterData/LogoUseTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataLogoUseTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLogoUseTypeLookupByValueGet$Response(params?: MasterDataLogoUseTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataLogoUseTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataLogoUseTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataLogoUseTypeLookupByValueGet(params?: MasterDataLogoUseTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataLogoUseTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataMedicalAidGet()` */
  static readonly MasterDataMedicalAidGetPath = '/MasterData/MedicalAid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataMedicalAidGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMedicalAidGet$Response(params?: MasterDataMedicalAidGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataMedicalAidGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataMedicalAidGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMedicalAidGet(params?: MasterDataMedicalAidGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataMedicalAidGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataMedicalAidSchemeMedicalAidIdGet()` */
  static readonly MasterDataMedicalAidSchemeMedicalAidIdGetPath = '/MasterData/MedicalAidScheme/{medicalAidId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataMedicalAidSchemeMedicalAidIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMedicalAidSchemeMedicalAidIdGet$Response(params: MasterDataMedicalAidSchemeMedicalAidIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataMedicalAidSchemeMedicalAidIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataMedicalAidSchemeMedicalAidIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMedicalAidSchemeMedicalAidIdGet(params: MasterDataMedicalAidSchemeMedicalAidIdGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataMedicalAidSchemeMedicalAidIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet()` */
  static readonly MasterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGetPath = '/MasterData/MedicalAidOption/{medicalAidId}/{medicalAidSchemeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet$Response(params: MasterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet(params: MasterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataMedicalAidOptionMedicalAidIdMedicalAidSchemeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataMedicalAidLookupByKeyPost()` */
  static readonly MasterDataMedicalAidLookupByKeyPostPath = '/MasterData/MedicalAidLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataMedicalAidLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataMedicalAidLookupByKeyPost$Response(params?: MasterDataMedicalAidLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataMedicalAidLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataMedicalAidLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataMedicalAidLookupByKeyPost(params?: MasterDataMedicalAidLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataMedicalAidLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataMedicalAidLookupByValueGet()` */
  static readonly MasterDataMedicalAidLookupByValueGetPath = '/MasterData/MedicalAidLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataMedicalAidLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMedicalAidLookupByValueGet$Response(params?: MasterDataMedicalAidLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataMedicalAidLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataMedicalAidLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataMedicalAidLookupByValueGet(params?: MasterDataMedicalAidLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataMedicalAidLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataNappiCodesGet()` */
  static readonly MasterDataNappiCodesGetPath = '/MasterData/NappiCodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataNappiCodesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataNappiCodesGet$Response(params?: MasterDataNappiCodesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<NappiCodeListModel>>> {
    return masterDataNappiCodesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataNappiCodesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataNappiCodesGet(params?: MasterDataNappiCodesGet$Params, context?: HttpContext): Observable<Array<NappiCodeListModel>> {
    return this.masterDataNappiCodesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<NappiCodeListModel>>): Array<NappiCodeListModel> => r.body)
    );
  }

  /** Path part for operation `masterDataNappiCodeLookupByKeyPost()` */
  static readonly MasterDataNappiCodeLookupByKeyPostPath = '/MasterData/NappiCodeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataNappiCodeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataNappiCodeLookupByKeyPost$Response(params?: MasterDataNappiCodeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<NappiCodeListModel>>> {
    return masterDataNappiCodeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataNappiCodeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataNappiCodeLookupByKeyPost(params?: MasterDataNappiCodeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<NappiCodeListModel>> {
    return this.masterDataNappiCodeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<NappiCodeListModel>>): Array<NappiCodeListModel> => r.body)
    );
  }

  /** Path part for operation `masterDataNappiCodeLookupByValueGet()` */
  static readonly MasterDataNappiCodeLookupByValueGetPath = '/MasterData/NappiCodeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataNappiCodeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataNappiCodeLookupByValueGet$Response(params?: MasterDataNappiCodeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<NappiCodeListModel>>> {
    return masterDataNappiCodeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataNappiCodeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataNappiCodeLookupByValueGet(params?: MasterDataNappiCodeLookupByValueGet$Params, context?: HttpContext): Observable<Array<NappiCodeListModel>> {
    return this.masterDataNappiCodeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<NappiCodeListModel>>): Array<NappiCodeListModel> => r.body)
    );
  }

  /** Path part for operation `masterDataNappiCodeLookupByCodePost()` */
  static readonly MasterDataNappiCodeLookupByCodePostPath = '/MasterData/NappiCodeLookupByCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataNappiCodeLookupByCodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataNappiCodeLookupByCodePost$Response(params?: MasterDataNappiCodeLookupByCodePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<NappiCodeDescriptionModel>>> {
    return masterDataNappiCodeLookupByCodePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataNappiCodeLookupByCodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataNappiCodeLookupByCodePost(params?: MasterDataNappiCodeLookupByCodePost$Params, context?: HttpContext): Observable<Array<NappiCodeDescriptionModel>> {
    return this.masterDataNappiCodeLookupByCodePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<NappiCodeDescriptionModel>>): Array<NappiCodeDescriptionModel> => r.body)
    );
  }

  /** Path part for operation `masterDataOrganizationRolesGet()` */
  static readonly MasterDataOrganizationRolesGetPath = '/MasterData/OrganizationRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataOrganizationRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationRolesGet$Response(params?: MasterDataOrganizationRolesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataOrganizationRolesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataOrganizationRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationRolesGet(params?: MasterDataOrganizationRolesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataOrganizationRolesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataOrganizationRoleLookupByKeyPost()` */
  static readonly MasterDataOrganizationRoleLookupByKeyPostPath = '/MasterData/OrganizationRoleLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataOrganizationRoleLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataOrganizationRoleLookupByKeyPost$Response(params?: MasterDataOrganizationRoleLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataOrganizationRoleLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataOrganizationRoleLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataOrganizationRoleLookupByKeyPost(params?: MasterDataOrganizationRoleLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataOrganizationRoleLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataOrganizationRoleLookupByValueGet()` */
  static readonly MasterDataOrganizationRoleLookupByValueGetPath = '/MasterData/OrganizationRoleLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataOrganizationRoleLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationRoleLookupByValueGet$Response(params?: MasterDataOrganizationRoleLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataOrganizationRoleLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataOrganizationRoleLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationRoleLookupByValueGet(params?: MasterDataOrganizationRoleLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataOrganizationRoleLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataOrganizationTypesGet()` */
  static readonly MasterDataOrganizationTypesGetPath = '/MasterData/OrganizationTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataOrganizationTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationTypesGet$Response(params?: MasterDataOrganizationTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataOrganizationTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataOrganizationTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationTypesGet(params?: MasterDataOrganizationTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataOrganizationTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataOrganizationTypeLookupByKeyPost()` */
  static readonly MasterDataOrganizationTypeLookupByKeyPostPath = '/MasterData/OrganizationTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataOrganizationTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataOrganizationTypeLookupByKeyPost$Response(params?: MasterDataOrganizationTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataOrganizationTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataOrganizationTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataOrganizationTypeLookupByKeyPost(params?: MasterDataOrganizationTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataOrganizationTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataOrganizationTypeLookupByValueGet()` */
  static readonly MasterDataOrganizationTypeLookupByValueGetPath = '/MasterData/OrganizationTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataOrganizationTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationTypeLookupByValueGet$Response(params?: MasterDataOrganizationTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataOrganizationTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataOrganizationTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataOrganizationTypeLookupByValueGet(params?: MasterDataOrganizationTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataOrganizationTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPracticeTypesGet()` */
  static readonly MasterDataPracticeTypesGetPath = '/MasterData/PracticeTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPracticeTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPracticeTypesGet$Response(params?: MasterDataPracticeTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataPracticeTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPracticeTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPracticeTypesGet(params?: MasterDataPracticeTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataPracticeTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPracticeTypeLookupByKeyPost()` */
  static readonly MasterDataPracticeTypeLookupByKeyPostPath = '/MasterData/PracticeTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPracticeTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataPracticeTypeLookupByKeyPost$Response(params?: MasterDataPracticeTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataPracticeTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPracticeTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataPracticeTypeLookupByKeyPost(params?: MasterDataPracticeTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataPracticeTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPracticeTypeLookupByValueGet()` */
  static readonly MasterDataPracticeTypeLookupByValueGetPath = '/MasterData/PracticeTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPracticeTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPracticeTypeLookupByValueGet$Response(params?: MasterDataPracticeTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataPracticeTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPracticeTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPracticeTypeLookupByValueGet(params?: MasterDataPracticeTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataPracticeTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataProductBenefitQueryGet()` */
  static readonly MasterDataProductBenefitQueryGetPath = '/MasterData/ProductBenefitQuery';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataProductBenefitQueryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataProductBenefitQueryGet$Response(params?: MasterDataProductBenefitQueryGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataProductBenefitQueryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataProductBenefitQueryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataProductBenefitQueryGet(params?: MasterDataProductBenefitQueryGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataProductBenefitQueryGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataProductBenefitLookupByKeyPost()` */
  static readonly MasterDataProductBenefitLookupByKeyPostPath = '/MasterData/ProductBenefitLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataProductBenefitLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataProductBenefitLookupByKeyPost$Response(params?: MasterDataProductBenefitLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataProductBenefitLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataProductBenefitLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataProductBenefitLookupByKeyPost(params?: MasterDataProductBenefitLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataProductBenefitLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataProductBenefitLookupByValueGet()` */
  static readonly MasterDataProductBenefitLookupByValueGetPath = '/MasterData/ProductBenefitLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataProductBenefitLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataProductBenefitLookupByValueGet$Response(params?: MasterDataProductBenefitLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataProductBenefitLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataProductBenefitLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataProductBenefitLookupByValueGet(params?: MasterDataProductBenefitLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataProductBenefitLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataProfessionsGet()` */
  static readonly MasterDataProfessionsGetPath = '/MasterData/Professions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataProfessionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataProfessionsGet$Response(params?: MasterDataProfessionsGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataProfessionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataProfessionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataProfessionsGet(params?: MasterDataProfessionsGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataProfessionsGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataProfessionLookupByKeyPost()` */
  static readonly MasterDataProfessionLookupByKeyPostPath = '/MasterData/ProfessionLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataProfessionLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataProfessionLookupByKeyPost$Response(params?: MasterDataProfessionLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataProfessionLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataProfessionLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataProfessionLookupByKeyPost(params?: MasterDataProfessionLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataProfessionLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataProfessionLookupByValueGet()` */
  static readonly MasterDataProfessionLookupByValueGetPath = '/MasterData/ProfessionLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataProfessionLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataProfessionLookupByValueGet$Response(params?: MasterDataProfessionLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataProfessionLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataProfessionLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataProfessionLookupByValueGet(params?: MasterDataProfessionLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataProfessionLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPublicHolidaysGet()` */
  static readonly MasterDataPublicHolidaysGetPath = '/MasterData/PublicHolidays';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPublicHolidaysGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPublicHolidaysGet$Response(params?: MasterDataPublicHolidaysGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<PublicHolidayListModel>>> {
    return masterDataPublicHolidaysGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPublicHolidaysGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPublicHolidaysGet(params?: MasterDataPublicHolidaysGet$Params, context?: HttpContext): Observable<Array<PublicHolidayListModel>> {
    return this.masterDataPublicHolidaysGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<PublicHolidayListModel>>): Array<PublicHolidayListModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPublicHolidayLookupByKeyPost()` */
  static readonly MasterDataPublicHolidayLookupByKeyPostPath = '/MasterData/PublicHolidayLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPublicHolidayLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataPublicHolidayLookupByKeyPost$Response(params?: MasterDataPublicHolidayLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<PublicHolidayListModel>>> {
    return masterDataPublicHolidayLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPublicHolidayLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataPublicHolidayLookupByKeyPost(params?: MasterDataPublicHolidayLookupByKeyPost$Params, context?: HttpContext): Observable<Array<PublicHolidayListModel>> {
    return this.masterDataPublicHolidayLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<PublicHolidayListModel>>): Array<PublicHolidayListModel> => r.body)
    );
  }

  /** Path part for operation `masterDataPublicHolidayLookupByValueGet()` */
  static readonly MasterDataPublicHolidayLookupByValueGetPath = '/MasterData/PublicHolidayLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataPublicHolidayLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPublicHolidayLookupByValueGet$Response(params?: MasterDataPublicHolidayLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<PublicHolidayListModel>>> {
    return masterDataPublicHolidayLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataPublicHolidayLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataPublicHolidayLookupByValueGet(params?: MasterDataPublicHolidayLookupByValueGet$Params, context?: HttpContext): Observable<Array<PublicHolidayListModel>> {
    return this.masterDataPublicHolidayLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<PublicHolidayListModel>>): Array<PublicHolidayListModel> => r.body)
    );
  }

  /** Path part for operation `masterDataQualificationsQualificationTypeIdGet()` */
  static readonly MasterDataQualificationsQualificationTypeIdGetPath = '/MasterData/Qualifications/{qualificationTypeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataQualificationsQualificationTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataQualificationsQualificationTypeIdGet$Response(params: MasterDataQualificationsQualificationTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>> {
    return masterDataQualificationsQualificationTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataQualificationsQualificationTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataQualificationsQualificationTypeIdGet(params: MasterDataQualificationsQualificationTypeIdGet$Params, context?: HttpContext): Observable<Array<QualificationKeyValueCodeModel>> {
    return this.masterDataQualificationsQualificationTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>): Array<QualificationKeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataQualificationLookupByKeyPost()` */
  static readonly MasterDataQualificationLookupByKeyPostPath = '/MasterData/QualificationLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataQualificationLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataQualificationLookupByKeyPost$Response(params?: MasterDataQualificationLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>> {
    return masterDataQualificationLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataQualificationLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataQualificationLookupByKeyPost(params?: MasterDataQualificationLookupByKeyPost$Params, context?: HttpContext): Observable<Array<QualificationKeyValueCodeModel>> {
    return this.masterDataQualificationLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>): Array<QualificationKeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataQualificationLookupByValueGet()` */
  static readonly MasterDataQualificationLookupByValueGetPath = '/MasterData/QualificationLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataQualificationLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataQualificationLookupByValueGet$Response(params?: MasterDataQualificationLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>> {
    return masterDataQualificationLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataQualificationLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataQualificationLookupByValueGet(params?: MasterDataQualificationLookupByValueGet$Params, context?: HttpContext): Observable<Array<QualificationKeyValueCodeModel>> {
    return this.masterDataQualificationLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>): Array<QualificationKeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataQualificationTypesGet()` */
  static readonly MasterDataQualificationTypesGetPath = '/MasterData/QualificationTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataQualificationTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataQualificationTypesGet$Response(params?: MasterDataQualificationTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataQualificationTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataQualificationTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataQualificationTypesGet(params?: MasterDataQualificationTypesGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataQualificationTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataQualificationTypeLookupByKeyPost()` */
  static readonly MasterDataQualificationTypeLookupByKeyPostPath = '/MasterData/QualificationTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataQualificationTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataQualificationTypeLookupByKeyPost$Response(params?: MasterDataQualificationTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataQualificationTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataQualificationTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataQualificationTypeLookupByKeyPost(params?: MasterDataQualificationTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataQualificationTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataQualificationTypeLookupByValueGet()` */
  static readonly MasterDataQualificationTypeLookupByValueGetPath = '/MasterData/QualificationTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataQualificationTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataQualificationTypeLookupByValueGet$Response(params?: MasterDataQualificationTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
    return masterDataQualificationTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataQualificationTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataQualificationTypeLookupByValueGet(params?: MasterDataQualificationTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.masterDataQualificationTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataRelationshipTypesGet()` */
  static readonly MasterDataRelationshipTypesGetPath = '/MasterData/RelationshipTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataRelationshipTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataRelationshipTypesGet$Response(params?: MasterDataRelationshipTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>> {
    return masterDataRelationshipTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataRelationshipTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataRelationshipTypesGet(params?: MasterDataRelationshipTypesGet$Params, context?: HttpContext): Observable<Array<RelationshipTypeKeyValueModel>> {
    return this.masterDataRelationshipTypesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>): Array<RelationshipTypeKeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataRelationshipTypeLookupByKeyPost()` */
  static readonly MasterDataRelationshipTypeLookupByKeyPostPath = '/MasterData/RelationshipTypeLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataRelationshipTypeLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataRelationshipTypeLookupByKeyPost$Response(params?: MasterDataRelationshipTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>> {
    return masterDataRelationshipTypeLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataRelationshipTypeLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataRelationshipTypeLookupByKeyPost(params?: MasterDataRelationshipTypeLookupByKeyPost$Params, context?: HttpContext): Observable<Array<RelationshipTypeKeyValueModel>> {
    return this.masterDataRelationshipTypeLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>): Array<RelationshipTypeKeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataRelationshipTypeLookupByValueGet()` */
  static readonly MasterDataRelationshipTypeLookupByValueGetPath = '/MasterData/RelationshipTypeLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataRelationshipTypeLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataRelationshipTypeLookupByValueGet$Response(params?: MasterDataRelationshipTypeLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>> {
    return masterDataRelationshipTypeLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataRelationshipTypeLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataRelationshipTypeLookupByValueGet(params?: MasterDataRelationshipTypeLookupByValueGet$Params, context?: HttpContext): Observable<Array<RelationshipTypeKeyValueModel>> {
    return this.masterDataRelationshipTypeLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>): Array<RelationshipTypeKeyValueModel> => r.body)
    );
  }

  /** Path part for operation `masterDataServiceCategoriesGet()` */
  static readonly MasterDataServiceCategoriesGetPath = '/MasterData/ServiceCategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceCategoriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceCategoriesGet$Response(params?: MasterDataServiceCategoriesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceCategoriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceCategoriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceCategoriesGet(params?: MasterDataServiceCategoriesGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceCategoriesGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataServiceCategoryLookupByKeyPost()` */
  static readonly MasterDataServiceCategoryLookupByKeyPostPath = '/MasterData/ServiceCategoryLookupByKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceCategoryLookupByKeyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataServiceCategoryLookupByKeyPost$Response(params?: MasterDataServiceCategoryLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceCategoryLookupByKeyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceCategoryLookupByKeyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  masterDataServiceCategoryLookupByKeyPost(params?: MasterDataServiceCategoryLookupByKeyPost$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceCategoryLookupByKeyPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

  /** Path part for operation `masterDataServiceCategoryLookupByValueGet()` */
  static readonly MasterDataServiceCategoryLookupByValueGetPath = '/MasterData/ServiceCategoryLookupByValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `masterDataServiceCategoryLookupByValueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceCategoryLookupByValueGet$Response(params?: MasterDataServiceCategoryLookupByValueGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueCodeModel>>> {
    return masterDataServiceCategoryLookupByValueGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `masterDataServiceCategoryLookupByValueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  masterDataServiceCategoryLookupByValueGet(params?: MasterDataServiceCategoryLookupByValueGet$Params, context?: HttpContext): Observable<Array<KeyValueCodeModel>> {
    return this.masterDataServiceCategoryLookupByValueGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<KeyValueCodeModel>>): Array<KeyValueCodeModel> => r.body)
    );
  }

}
